import SOP0 from './assets/SOP.png';
import SOP1 from './assets/SOP-1.png';
import SOP2 from './assets/SOP-2.png';
import SOP4 from './assets/SOP-4.png';
import SOP5 from './assets/SOP-5.png';
import SOP7 from './assets/SOP-7.png';
import styled from 'styled-components';
import BSCarousel from 'react-bootstrap/Carousel';

const CarouselComp = ({ className }) => {
	return (
		<BSCarousel className={className} fade variant="dark" interval={null}>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>
					<h3>STEP 1</h3>
					Carrier Barcode is read by SMARTEye reader at S074.
					<br />
					Data is passed to SMARTInspect PLC.
				</BSCarousel.Caption>
				<img src={SOP1} />
			</BSCarousel.Item>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>
					<h3>STEP 2</h3>
					Sticker Barcode is read by AVI reader at S079.
					<br />
					AVI reader is part of PPC Conveyor logic, data is passed to CSC logic, and then to SMARTInspect
				</BSCarousel.Caption>
				<img src={SOP2} />
			</BSCarousel.Item>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>
					<h3>STEP 3</h3>
					Reader data is compared, AVI data is used if available. If not, the SMARTEye data is used.
				</BSCarousel.Caption>
				<img src={SOP0} />
			</BSCarousel.Item>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>
					<h3>STEP 4</h3>Carrier moves onto S080 and carrier detect prox is ON
				</BSCarousel.Caption>
				<img src={SOP4} />
			</BSCarousel.Item>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>
					<h3>STEP 5</h3>
					Carrier engages encoder and breaks the body detect photoeye.
					<br />
					At this point, the carrier data is moved to the inspect queue position.
				</BSCarousel.Caption>
				<img src={SOP5} />
			</BSCarousel.Item>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>
					<h3>STEP 6</h3>
					After a set number of encoder counts the LEDs will begin to flash and the cameras begin taking photos based on provided data.
				</BSCarousel.Caption>
				<img src={SOP0} />
			</BSCarousel.Item>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>
					<h3>STEP 7</h3>
					The unit exits the inspection area and the system is reset to prepare for the next unit.
				</BSCarousel.Caption>
				<img src={SOP7} />
			</BSCarousel.Item>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>NOTE: Throughout this process the individual rollerbed prox switches are used to shift queue and track data.</BSCarousel.Caption>
				<img src={SOP0} />
			</BSCarousel.Item>
		</BSCarousel>
	);
};

const SOP = styled(CarouselComp)`
	width: 65vw;
	margin: 0 auto;

	& img {
		display: block;
		margin: 0 auto;
		width: 32vw;
	}

	.carousel-inner {
		border-radius: 2em;
	}

	.carousel-indicators {
		bottom: -20px;
	}

	.carousel-control-prev,
	.carousel-control-next {
		min-height: 60vh;
	}

	.carousel-caption {
		font-weight: bold;
		position: relative;
		background: white;
		color: #000;
		width: 100%;
		left: 0;
		right: 0;
		bottom: 0;
		& h3 {
			text-align: center;
		}
	}

	@media screen and (max-width: 480px) {
		width: 89vw;
	}
`;

export default SOP;
